<app-modal
  #modal
  [modalConfig]="{
    titleText: 'LMS Course',
    options: { size: 'm' },
    headerClass: ['modal-header', 'bg-primary', 'text-white', 'border-0'],
    bodyClass: ['p-0'],
    customFooter: true
  }"
  (isClosing)="resetModal()"
  (isDismissing)="resetModal()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="w-100" style="background-color: #fff; min-height: 500px">
    <div class="container" *ngIf="course">
      <div class="form-group mb-3">
        <label class="form-label fw-bold" for="title">Title</label>
        <input
          type="text"
          class="form-control"
          id="title"
          value="{{ course.title }}"
          readonly="readonly"
          disabled />
      </div>
      <div class="form-group mb-3" *ngIf="course.preview_link">
        <label class="form-label fw-bold" for="preview">Preview</label>
        <a href="{{ course.preview_link }}" target="_blank">{{
          course.preview_link
        }}</a>
      </div>

      <div class="form-group mb-3">
        <label class="form-label fw-bold" for="status">Status</label>
        <ng-select
          labelForId="status"
          [items]="['draft', 'published', 'archived']"
          bindLabel="key"
          [clearable]="false"
          [searchable]="false"
          bindValue="value"
          [(ngModel)]="course.status"
          name="status"
          (ngModelChange)="updateStatus()"></ng-select>
      </div>

      <div class="form-group mt-2">
        <p class="fw-bold mb-1">Sharing</p>
        <div class="d-flex align-items-center justify-content-between mb-3">
          <label
            class="form-label fw-normal my-0"
            for="share-form-across-districts"
            >Share form across districts?</label
          >
          <button
            aria-label="Share form across districts"
            class="form-switch btn-reset">
            <input
              class="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="share-form-across-districts"
              [checked]="course.is_shared === 1"
              (change)="toggleSharing($event)" />
          </button>
        </div>
      </div>
      <ng-container *ngIf="course.is_shared === 1">
        <div class="mb-3">
          <label class="mb-2">
            Share with these districts (default is share across all your
            districts):
          </label>
          <app-district-select
            #shareWithDistrictSelect
            (selectedDistrictList)="handleShareDistricts($event)"
            [defaultDistricts]="districtsSharedWith"
            [isMulti]="true"></app-district-select>
        </div>
        <div class="mb-3">
          <label class="mb-2">Exclude these districts:</label>
          <app-district-select
            #excludeFromDistrictSelect
            (selectedDistrictList)="handleExcludeDistricts($event)"
            [defaultDistricts]="districtsExcludedFrom"
            [isMulti]="true"></app-district-select>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="isLoading">
      <div class="w-100" style="background-color: #fff; height: 400px">
        <app-loader></app-loader>
      </div>
    </ng-container>
  </div>
  <div footerContent>
    <div class="d-flex justify-content-between">
      <ng-container *ngIf="course?.status === LmsCourseStatus.ARCHIVED">
        <button
          aria-label="delete course button"
          class="btn px-1 btn-txt-delete"
          type="button"
          [autoClose]="'outside'"
          [ngbPopover]="deleteConfirm"
          [popoverTitle]="'Delete course'"
          #popover="ngbPopover">
          Delete
        </button>
        <ng-template #deleteConfirm>
          Are you sure you want to delete this course?
          <div class="text-end mt-2">
            <button
              type="button"
              class="btn btn-secondary btn-sm px-3 m-1"
              (click)="popover.close()">
              No
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm px-3 m-1"
              (click)="deleteCourse(); popover.close()">
              Yes
            </button>
          </div>
        </ng-template>
      </ng-container>
      <button
        type="button"
        class="btn btn-md btn-primary ms-auto"
        (click)="modal.close(); resetModal()">
        Done
      </button>
    </div>
  </div>
</app-modal>
